import { atom } from 'jotai';

export const mobileOpenAtom = atom<boolean>(false);
